// Utility for fetching bills from backend
import API_URL from '../config/api';

export async function fetchBills(token: string) {
  const res = await fetch(`${API_URL}/bills`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to fetch bills');
  const data = await res.json();
  return data.bills || [];
}

export async function addBill(bill: any, token: string) {
  const res = await fetch(`${API_URL}/bills`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    body: JSON.stringify(bill)
  });
  if (!res.ok) {
    let errMsg = `Server error ${res.status}`;
    try { const d = await res.json(); errMsg = d.message || d.error || errMsg; } catch {}
    throw new Error(errMsg);
  }
  const data = await res.json();
  return data.bill;
}

export async function updateBill(id: string | number, bill: any, token: string) {
  const res = await fetch(`${API_URL}/bills/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
    body: JSON.stringify(bill)
  });
  if (!res.ok) throw new Error('Failed to update bill');
  const data = await res.json();
  return data.bill;
}

export async function deleteBill(id: string | number, token: string) {
  const res = await fetch(`${API_URL}/bills/${id}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!res.ok) throw new Error('Failed to delete bill');
  return true;
}
